"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callCMSAccessTokenApi = callCMSAccessTokenApi;
exports.cmsCommonResultApi = cmsCommonResultApi;
exports.dynamicSplash = dynamicSplash;
var _ApiConst = require("../../../common/utils/ApiConst");
var _genericFetch = _interopRequireDefault(require("../../../common/api/genericFetch"));
// import { apiCall } from '../../../../common/api/api';

function callCMSAccessTokenApi(requestParams) {
  const apiEndPoint = _ApiConst.CMS_TOKEN;
  const options = {};
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, header: 2, appendHeader: { deviceId: deviceId } });
}
function cmsCommonResultApi(params) {
  const {
    channel,
    pageType
  } = params;
  const apiEndPoint = `${_ApiConst.CMS_COMMON_API}${pageType}/details?channel=${channel}`;
  const options = {};
  options.method = _ApiConst.API_PARAMS.GET;
  const formData = null;
  const enableCache = true;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options,
    formData,
    enableCache
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, header: 2, appendHeader: { deviceId: deviceId } });
}
function dynamicSplash(params) {
  var _params$data;
  const apiEndPoint = _ApiConst.GET_DYNAMIC_SPLASH + `?onboardingscreenid=${params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.param}`;
  const options = {};
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, header: 2, appendHeader: { deviceId: deviceId } });
}